
import { Component, Vue } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'
import Price from '@/components/price/index.vue'
import Footer from '@/common/footer.vue'
import {
  onRegister,
  getCode,
  onPasswordLogin,
  onLogin,
  updatePassword,
  getWxUrl,
} from '@/services/http'
import { writeCookie, readCookie } from '@/tools/tools'

@Component({
  components: {
    Price,
    Footer,
  },
})
export default class extends Vue {
  phonenumber: string = ''

  code: string = ''

  password: string = ''

  updateTelphone: string = ''

  updateCode: string = ''

  updatePass: string = ''

  updateAgainPassWord: string = ''

  registertelphone: string = ''

  codeTelphone: string = ''

  codePassword: string = ''

  registerpassword: string = ''

  registercode: string = ''

  currentIndex: number = 1

  //  是否获取验证码
  isVerification: boolean = false

  //  找回密码
  isGetCode: boolean = false

  isCode: boolean = true // 验证码登录（true）,密码登录（false）

  imgSrc: string = ''

  // 是否同意用户协议
  isAgree: boolean = false

  count: number = 60

  timer: any = null

  tabs: any[] = [
    // { id: 0, title: '注册' },
    { id: 1, title: '验证码登录' },
  ]

  @Action('user/setUserInfoList') setUserInfoList!: Function

  @State('user') userinfor: any

  mounted() {
    ;(document as any)
      .querySelector('.login-tab')
      .addEventListener('keypress', this.pressFunc, true)
  }

  pressFunc(event: any) {
    if (event.keyCode === 13) {
      if (this.isGetCode) {
        this.updatePassword()
      } else if (this.currentIndex === 0) {
        this.register()
      } else {
        this.signIn()
      }
    }
  }

  private selectTab(index: string) {
    this.currentIndex = Number(index)
    if (this.currentIndex === 1) {
      this.imgSrc = `${process.env.VUE_APP_BASE_URL}/servlet/safecode?${Math.random()}`
    }
  }

  private codeLogin() {
    this.currentIndex = 1
    this.isCode = !this.isCode
    this.changeSrc()
  }

  private changeSrc() {
    this.imgSrc = `${process.env.VUE_APP_BASE_URL}/servlet/safecode?${Math.random()}`
  }

  private async getCode() {
    // eslint-disable-next-line no-nested-ternary
    const phone = this.isGetCode
      ? this.updateTelphone
      : this.currentIndex === 1
      ? this.codeTelphone
      : this.phonenumber
    const res: any = await getCode({
      phone,
      src: 3,
    })
    if (res.data.code === 100) {
      this.$message.success('手机验证码已经成功发送，请注意查收！')
      this.countDown()
      this.isVerification = true
    } else {
      this.$message.error(res.data.message)
    }
  }

  // 注册
  private async register() {
    const res: any = await onRegister({
      mobileNo: this.phonenumber,
      smsCode: this.code,
      password: this.password,
      equip: '',
      version: '',
      model: '',
      equipVersion: '',
      equipMeid: '',
      companyId: 1,
      userSrc: 3,
    })
    if (res.data.code === 100) {
      writeCookie('accessToken', res.data.data)
      await this.setUserInfoList()
      const anchor = readCookie('anchor')
      if (anchor) {
        const obj: any = {
          accessToken: res.data.data,
          userName: this.userinfor.userinfolist.nickName,
          userId: this.userinfor.userinfolist.id,
          userPhoto: this.userinfor.userinfolist.headImgUrl,
          macCode: '',
          phone: this.userinfor.userinfolist.phone,
        }

        if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
          delete obj.accessToken
          obj.token = res.data.data
          ;(this as any).webTransport.getUserLoginData(JSON.stringify(obj))
        } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
          delete obj.accessToken
          obj.token = res.data.data
          ;(window as any).QCefClient.invokeMethod('getUserLoginData', JSON.stringify(obj))
        } else {
          ;(window as any).JsIntrS.getUserLoginData(obj)
        }
      }
      const path: any = this.$route.query.redirect
      if (path) {
        this.$router.push(path)
      } else {
        this.$router.push('/')
      }
    } else {
      this.$message.error(res.data.message)
    }
  }

  // 比较版本
  compareVersion(v1: any, v2: any) {
    v1 = v1.split('.')
    v2 = v2.split('.')
    const len = Math.max(v1.length, v2.length)

    // 调整两个版本号位数相同
    while (v1.length < len) {
      v1.push('0')
    }
    while (v2.length < len) {
      v2.push('0')
    }

    // 循环判断每位数的大小
    for (let i = 0; i < len; i++) {
      const num1 = parseInt(v1[i])
      const num2 = parseInt(v2[i])

      if (num1 > num2) {
        return 1
      }
      if (num1 < num2) {
        return -1
      }
    }

    return 0
  }

  // 验证码登录
  private async onLogin() {
    const res: any = await onLogin({
      mobileNo: this.codeTelphone,
      smsCode: this.codePassword,
      equip: '',
      version: '',
      model: '',
      equipVersion: '',
      equipMeid: '',
      companyId: 1,
      userSrc: 3,
    })
    if (res.data.code === 100) {
      writeCookie('accessToken', res.data.data)
      await this.setUserInfoList()
      const anchor = readCookie('anchor')
      if (anchor) {
        const obj: any = {
          accessToken: res.data.data,
          userName: this.userinfor.userinfolist.nickName,
          userId: this.userinfor.userinfolist.id,
          userPhoto: this.userinfor.userinfolist.headImgUrl,
          macCode: '',
          phone: this.userinfor.userinfolist.phone,
        }
        if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
          delete obj.accessToken
          obj.token = res.data.data
          ;(this as any).webTransport.getUserLoginData(JSON.stringify(obj))
        } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
          delete obj.accessToken
          obj.token = res.data.data
          ;(window as any).QCefClient.invokeMethod('getUserLoginData', JSON.stringify(obj))
        } else {
          ;(window as any).JsIntrS.getUserLoginData(obj)
        }
      }
      const path: any = this.$route.query.redirect
      if (path) {
        this.$router.push(path)
      } else {
        this.$router.push('/')
      }
    } else {
      this.$message.error(res.data.message)
    }
  }

  signIn() {
    if (this.isCode) {
      this.onLogin()
    } else {
      this.onPasswordLogin()
    }
  }

  // 密码登录
  private async onPasswordLogin() {
    const res: any = await onPasswordLogin({
      mobileNo: this.registertelphone,
      password: this.registerpassword,
      verifyCode: this.registercode,
      equip: '',
      version: '',
      model: '',
      equipVersion: '',
      equipMeid: '',
    })
    if (res.data.code === 100) {
      writeCookie('accessToken', res.data.data)
      await this.setUserInfoList()
      const anchor = readCookie('anchor')
      if (anchor) {
        const obj: any = {
          accessToken: res.data.data,
          userName: this.userinfor.userinfolist.nickName,
          userId: this.userinfor.userinfolist.id,
          userPhoto: this.userinfor.userinfolist.headImgUrl,
          macCode: '',
          phone: this.userinfor.userinfolist.phone,
        }
        if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
          delete obj.accessToken
          obj.token = res.data.data
          ;(this as any).webTransport.getUserLoginData(JSON.stringify(obj))
        } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
          delete obj.accessToken
          obj.token = res.data.data
          ;(window as any).QCefClient.invokeMethod('getUserLoginData', JSON.stringify(obj))
        } else {
          ;(window as any).JsIntrS.getUserLoginData(obj)
        }
      }
      const path: any = this.$route.query.redirect
      if (path) {
        this.$router.push(path)
      } else {
        this.$router.push('/')
      }
    } else {
      this.changeSrc()
      this.$message.error(res.data.message)
    }
  }

  // 微信登录
  private async getWxUrl() {
    const res: any = await getWxUrl({
      type: 'web',
      biz: 'login',
      version: '',
      model: '',
      equipVersion: '',
      equipMeid: '',
      companyId: 1,
    })
    if (res.data.code === 100) {
      window.location.href = res.data.data
    } else {
      this.$message.error(res.data.message)
    }
  }

  private async updatePassword() {
    if (
      this.updatePass !== '' &&
      this.updateAgainPassWord !== '' &&
      this.updatePass === this.updateAgainPassWord
    ) {
      const res: any = await updatePassword({
        mobileNo: this.updateTelphone,
        smsCode: this.updateCode,
        password: this.updatePass,
        equip: '',
        version: '',
      })
      if (res.data.code === 100) {
        writeCookie('accessToken', res.data.data)
        await this.setUserInfoList()
        const anchor = readCookie('anchor')
        if (anchor) {
          const obj: any = {
            accessToken: res.data.data,
            userName: this.userinfor.userinfolist.nickName,
            userId: this.userinfor.userinfolist.id,
            userPhoto: this.userinfor.userinfolist.headImgUrl,
            macCode: '',
            phone: this.userinfor.userinfolist.phone,
          }
          if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
            delete obj.accessToken
            obj.token = res.data.data
            ;(this as any).webTransport.getUserLoginData(JSON.stringify(obj))
          } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
            delete obj.accessToken
            obj.token = res.data.data
            ;(window as any).QCefClient.invokeMethod('getUserLoginData', JSON.stringify(obj))
          } else {
            ;(window as any).JsIntrS.getUserLoginData(obj)
          }
        }
        const path: any = this.$route.query.redirect
        if (path) {
          this.$router.push(path)
        } else {
          this.$router.push('/')
        }
      } else {
        this.$message.error(res.data.message)
      }
    } else {
      this.$message.error('两次输入密码不一致')
    }
  }

  // 倒计时
  countDown() {
    this.timer = setInterval(() => {
      this.count -= 1
      if (this.count <= 0) {
        clearInterval(Number(this.timer))
        this.isVerification = false
      }
    }, 1000)
  }
}
